import { Button } from '../button/Button';
import { 
	UpgradeModalRoot,
	ModalTitle,
	ModalSubtitle,
	ModalContentHeader,
	ModalButtonWrapper,
	TilesWrapper,
} from './UpgradePagesModal.styled';
import { UpgradePagesTile } from './UpgradePagesTile';

interface Props {
  modalTitle: string;
  modalSubtitle: string;
  modalContentHeader: string;
  tiles: Array<{
    icon: string;
    tileTitle: string;
    tileDescription: string;
    isFullWidth?: boolean;
    isHorizontal?: boolean;
  }>;
  primaryButtonLabelModal: string;
  secondaryButtonLabelModal: string;
  onClose: () => void;
  onPrimaryButtonClick: () => Promise<void>;
  isSubmitting: boolean;
}

export const UpgradePagesModal = ({ 
	modalTitle, 
	modalSubtitle,
	modalContentHeader,
	tiles,
	primaryButtonLabelModal,
	secondaryButtonLabelModal,
	onClose,
	onPrimaryButtonClick,
	isSubmitting,
}: Props) => {
	const handleClick = async () => {
		try {
			await onPrimaryButtonClick();
			onClose();
		} catch (error) {
			console.error('Error in modal:', error);
		}
	};
    
	return (
		<UpgradeModalRoot>
			<ModalTitle>{modalTitle}</ModalTitle>
			<ModalSubtitle>{modalSubtitle}</ModalSubtitle>
			{tiles && tiles.length > 0 && <ModalContentHeader>{modalContentHeader}</ModalContentHeader>}
			<TilesWrapper>
				{tiles && tiles.map((tile, index) => (
					<UpgradePagesTile
						key={index}
						icon={tile.icon}
						tileTitle={tile.tileTitle}
						tileDescription={tile.tileDescription}
						isFullWidth={tile.isFullWidth}
						isHorizontal={tile.isHorizontal}
					/>
				))}
			</TilesWrapper>
			<ModalButtonWrapper>
				<Button 
					size='large'
					variant='secondary'
					onClick={onClose}
					label={secondaryButtonLabelModal}
					disabled={isSubmitting}
				/>
				<Button 
					size='large'
					variant='primary'
					onClick={handleClick}
					label={primaryButtonLabelModal}
					disabled={isSubmitting}
				/>
			</ModalButtonWrapper>
		</UpgradeModalRoot>
	);
};
